export default __webpack_public_path__ + "static/media/dotted-welcome.3206c6b7.svg";